import { render, staticRenderFns } from "./ModalMensagem.vue?vue&type=template&id=6ed6640c&scoped=true"
import script from "./ModalMensagem.vue?vue&type=script&lang=js"
export * from "./ModalMensagem.vue?vue&type=script&lang=js"
import style0 from "./ModalMensagem.vue?vue&type=style&index=0&id=6ed6640c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed6640c",
  null
  
)

export default component.exports